import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient, type Client } from "@connectrpc/connect";
import { CATApp } from "@anu-its/cat-grpc-app-pb/js/anu/cat_app/cat_app_pb";
import { env } from "./env";

const transport = createConnectTransport({
  baseUrl: env.NEXT_PUBLIC_API_BASE_URL,
});

/**
 * The Connect client for making API requests to the CAT App's experience API.
 */
export const apiClient: Client<typeof CATApp> = createClient(CATApp, transport);
